import { render, staticRenderFns } from "./TopSection.vue?vue&type=template&id=05e1c5ef&scoped=true&"
import script from "./TopSection.vue?vue&type=script&lang=js&"
export * from "./TopSection.vue?vue&type=script&lang=js&"
import style0 from "./TopSection.vue?vue&type=style&index=0&id=05e1c5ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e1c5ef",
  null
  
)

export default component.exports